module.exports = __webpack_public_path__ + "static/media/nauka-pisania-na-klawiaturze-inf2-2.b272d80c.png";